// extracted by mini-css-extract-plugin
export default {"carouselContainer":"dataCarousel_carouselContainer__AxKbX","carouselText":"dataCarousel_carouselText__WUVx2"};